import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { ThemeProvider } from '@material-ui/core/styles'
import { createTheme } from '@material-ui/core'
import { ContextProvider } from './context/Context'

const theme = createTheme({
  palette: {
    common: {
      black: '#0a0b0f'
    },
    primary: {
      main: '#f0c74b'
    },
    secondary: {
      main: '#f7710b'
    }
  },
  typography: {
    fontFamily: '\'Nunito\', sans-serif',
    specialGradient: {
      background: 'rgb(10,11,15)',
      background: 'linear-gradient(73deg, rgba(10,11,15,1) 0%, rgba(22,25,33,1) 69%, rgba(17,19,26,1) 100%)'
    }
  }
})

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <ContextProvider>
      <App />
    </ContextProvider>
  </ThemeProvider>,
  document.getElementById('root')
)